module.exports = __webpack_public_path__ + "img/10016.fbbb46d4.jpg";